"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SUBMIT_ERRORS = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const submit = async params => {
  const {
    REACT_APP_PATH
  } = process.env;
  const FETCH_URL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/Submit.api");
  const formData = new FormData();
  if (localStorage.getItem("mco-shop-cart-guid")) {
    formData.append("cartGUID", localStorage.getItem("mco-shop-cart-guid"));
  }
  for (const key in params) {
    if (params[key] !== "") formData.append(key, params[key]);
  }
  const headers = {};
  if (localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }
  try {
    const response = await _axios.default.post(FETCH_URL, formData, {
      headers
    });
    const data = await response.data;
    return data;
  } catch (error) {
    return error;
  }
};
const SUBMIT_ERRORS = exports.SUBMIT_ERRORS = {
  address_missing: "ADDRESS_MISSING",
  cart_empty: "CART_EMPTY",
  interface_error: "CHECKOUT_NOT_SUBMITTED",
  parameter_missing: "CHECKOUT_NOT_SUBMITTED",
  paymentmethod_missing: "PAYMENT_METHOD_MISSING",
  rewardpoint_not_allowed: "REWARDPOINTS_NOT_ALLOWED",
  setup_error: "CHECKOUT_ERROR",
  shippingprovider_missing: "SHIPPING_PROVIDER_MISSING"
};
var _default = exports.default = submit;